<h1 mat-dialog-title><fa-icon [icon]="iconFastrac" size="lg"></fa-icon> FASTRAC&reg; Manager</h1>
<mat-dialog-content>
    <app-fastrac-management-page></app-fastrac-management-page>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button class="text-uppercase" (click)="onNoClick()" color="accent">Close</button>
</mat-dialog-actions>
